import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TipoPunitorioDto } from '@models/tipo-punitorio/tipoPunitorioDto.model';

@Component({
  selector: 'app-dialog-tipo-punitorio',
  templateUrl: './dialog-tipo-punitorio.component.html',
  styleUrls: ['./dialog-tipo-punitorio.component.css']
})
export class DialogTipoPunitorioComponent implements OnInit {

  action:string;
  local_data:any;
  form: any;
  formBuilder: FormBuilder = new FormBuilder;

  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogTipoPunitorioComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoPunitorioDto) {
    this.local_data = {...data};
    this.action = this.local_data.action;

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Valor: ["", Validators.compose([Validators.required,])],
    })

    if(this.action != AccionesDialog.Agregar){
      this.form.controls['Descripcion'].setValue(this.local_data.descripcion);
      this.form.controls['Valor'].setValue(this.local_data.valor);
    }
  }

  doAction(){
    this.dialogRef.close({event:this.action,data:this.local_data});
  }

  closeDialog(){
    this.dialogRef.close({event:AccionesDialog.Cancelar});
  }

  ngOnInit(): void {
  }
}
